import {
  OurFullCycleTeamIcon1,
  OurFullCycleTeamIcon2,
  OurFullCycleTeamIcon3,
  OurFullCycleTeamIcon4,
  OurFullCycleTeamIcon5,
  OurFullCycleTeamIcon6,
} from 'components/Common/Icon'
import { SubText, TitleH2 } from 'components/Common/Typography'
import React from 'react'
import { Accordion, Button, Col, Container, Row } from 'react-bootstrap'
import Link from 'next/link'
import LinkButton from 'components/LinkButton'

function OurFullCycleTeam() {
  return (
    <section className="our-full-cycle-team pt-120px pb-120px">
      <Container>
        <Row className="justify-content-between">
          <Col xl={5} className="mb-5 mb-xl-0">
            <TitleH2 text="Our Team Hierarchy" className="mb-4" />
            <SubText
              className="mb-2 pt-2 text-light"
              text="Product engineering services require fresh and young minds and our team members are fresh as daisies."
            />
            <div className="mt-4 mt-xl-5 pt-2 pt-xl-3">
              <LinkButton path="/our-team" className="text-decoration-none">
               Meet Our Team
              </LinkButton>
            </div>
          </Col>
          <Col xl={6}>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header><span className='title_xs'>01. Project Manager</span></Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex align-items-center">
                    <div className="content_text text_para text-light">
                      Our project managers are responsible for keeping timely
                      communication with clients, managing the team, and
                      ensuring that everything runs smoothly.
                    </div>
                    <div className="content_icon">
                      <OurFullCycleTeamIcon1 />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header><span className='title_xs'>02. Business Analyst</span></Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex align-items-center">
                    <div className="content_text text_para text-light">
                      Our business analyst assesses past business development
                      strategies and devises new goal-oriented strategies based
                      on business performance.
                    </div>
                    <div className="content_icon">
                      <OurFullCycleTeamIcon2 />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header><span className='title_xs'>03. UI-UX Designer</span></Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex align-items-center">
                    <div className="content_text text_para text-light">
                      The UI/UX designer ensures that the product engineering
                      services and solutions flow well from one aspect to the
                      next or one page to another. Their primary focus is to
                      enhance the user experience.
                    </div>
                    <div className="content_icon">
                      <OurFullCycleTeamIcon3 />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header><span className='title_xs'>04. Backend Developer</span></Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex align-items-center">
                    <div className="content_text text_para text-light">
                      Our backend developers strive to develop the
                      behind-the-scenes functionality of the solution. There is
                      usually more than one backend developer.
                    </div>
                    <div className="content_icon">
                      <OurFullCycleTeamIcon4 />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header><span className='title_xs'>05. Frontend Developer</span></Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex align-items-center">
                    <div className="content_text text_para text-light">
                      Our front-end developers ensure that the website grabs the
                      user&apos;s attention instantly. They usually tend to
                      focus on UI elements like images, text, tables, etc.
                    </div>
                    <div className="content_icon">
                      <OurFullCycleTeamIcon5 />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header><span className='title_xs'>06. QA Engineer</span></Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex align-items-center">
                    <div className="content_text text_para text-light ">
                      The QA engineer ensures that the software product
                      engineering services work as intended.
                    </div>
                    <div className="content_icon">
                      <OurFullCycleTeamIcon6 />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default OurFullCycleTeam
